import React, { useState } from 'react';
import './styles/global.css';

// ─── PAGES ────────────────────────────────────────────────────────────────────
import Dashboard          from './pages/Dashboard';
import BuyUSDT            from './pages/BuyUSDT';
import PaymentVerification from './pages/PaymentVerification';
import BuyOrderStatus     from './pages/BuyOrderStatus';
import Withdraw           from './pages/Withdraw';
import WithdrawalSubmitted from './pages/WithdrawalSubmitted';
import WithdrawalStatus   from './pages/WithdrawalStatus';
import Account            from './pages/Account';

// ─── ROUTE MAP ────────────────────────────────────────────────────────────────
// Each route is a function that receives { navigate } and returns JSX.
// To add a new page: create its file in /pages, import it here, add it to ROUTES.

const ROUTES = {
  dashboard:           (props) => <Dashboard           {...props} />,
  buy:                 (props) => <BuyUSDT             {...props} />,
  paymentVerification: (props) => <PaymentVerification {...props} />,
  buyOrderStatus:      (props) => <BuyOrderStatus      {...props} />,
  withdraw:            (props) => <Withdraw            {...props} />,
  withdrawalSubmitted: (props) => <WithdrawalSubmitted {...props} />,
  withdrawalStatus:    (props) => <WithdrawalStatus    {...props} />,
  account:             (props) => <Account             {...props} />,
};

// ─── APP ROOT ─────────────────────────────────────────────────────────────────
export default function App() {
  const [page, setPage] = useState('dashboard');

  // navigate(routeKey) — call this from any page to switch screens
  const navigate = (routeKey) => {
    if (ROUTES[routeKey]) {
      setPage(routeKey);
      // Scroll to top when switching pages
      const shell = document.querySelector('.phone-shell');
      if (shell) shell.scrollTop = 0;
    } else {
      console.warn(`[Tronzax] Unknown route: "${routeKey}"`);
    }
  };

  const CurrentPage = ROUTES[page] || ROUTES['dashboard'];

  return (
    <div className="phone-shell">
      <CurrentPage navigate={navigate} />
    </div>
  );
}
